// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/" + chunkId + "." + {"359": "55fa87ee","625": "0bb6fcbe",}[chunkId] + ".css"
}